import React from 'react';
import PropTypes from 'prop-types';
import OnboardingLayout from 'components/OnboardingLayout';
import ProgressBar from 'components/ProgressBar';
import { useGlobalState } from 'hooks/useGlobalState';
import { waitingMessages } from './utils';
import styles from './WaitingScreen.module.scss';

export default function WaitingScreen({ showProgressBar }) {
  const [{ waitingScreen }] = useGlobalState();
  const { waitingMessage: currentMessage } = waitingScreen;

  return (
    waitingScreen.visible && (
      <div className={styles.overlay} data-testid="waitingScreen">
        <OnboardingLayout promptEnabled={false}>
          <h1 className={styles.h1}>New instance loading...</h1>
          <div className={styles.imgWrap}>
            <img
              src="/assets/images/blippi.gif"
              alt="Blippi the robot is getting your instance ready!"
            />
          </div>
          <h2 className={styles.h2}>{waitingMessages[currentMessage]}</h2>
          {showProgressBar && <ProgressBar />}
        </OnboardingLayout>
      </div>
    )
  );
}

WaitingScreen.propTypes = {
  showProgressBar: PropTypes.bool,
};

WaitingScreen.defaultProps = {
  showProgressBar: false,
};
